/** Haptic feedback helper — wraps navigator.vibrate() with a user preference
 *  toggle persisted to localStorage. Disabled by default for accessibility +
 *  reduced-motion respect. Safe no-op on unsupported devices (iOS Safari,
 *  desktop, browsers without the Vibration API).
 */
const STORAGE_KEY = "nutramilo_haptic_enabled";

export function isHapticEnabled() {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

export function setHapticEnabled(enabled) {
  try {
    localStorage.setItem(STORAGE_KEY, String(!!enabled));
  } catch {
    /* storage disabled — ignore */
  }
}

export function isHapticSupported() {
  return typeof navigator !== "undefined" && typeof navigator.vibrate === "function";
}

/** Trigger a short haptic pulse if user has opted in.
 *  @param {number|number[]} pattern — ms duration (default 12) or pattern array.
 */
export function triggerHaptic(pattern = 12) {
  if (!isHapticEnabled()) return;
  if (!isHapticSupported()) return;
  // Respect prefers-reduced-motion as a safety net.
  try {
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }
  } catch { /* ignore */ }
  try {
    navigator.vibrate(pattern);
  } catch { /* ignore */ }
}
